export interface RentPin {
  id: string;
  latitude: number;
  longitude: number;
  address: string;
  city: string;
  postal_code?: string;
  bedrooms: number;
  monthly_rent: number;
  furnishing: 'Furnished' | 'Semi-Furnished' | 'Unfurnished';
  includes_hydro: boolean;
  includes_utilities: boolean;
  residents_type: 'Family' | 'Bachelor' | 'Mixed';
  deposit_paid: boolean;
  pets_allowed: boolean;
  pets_allowed_status?: string;
  square_footage?: number;
  property_type?: string;
  baths?: string;
  amenities?: string[];
  utilities_included?: string[];
  transit_distance?: string;
  school_rating?: number;
  description?: string;
  email?: string;
  phone?: string;
  anonymous_submission: boolean;
  reports: number;
  flagged_for_removal: boolean;
  created_at: string;
  updated_at: string;
}

export interface RentalSearch {
  id: string;
  search_type: 'LookingForRoom' | 'LookingForWhole';
  property_type?: string;
  budget: number;
  budget_per_room?: number;
  bhk_preference?: number;
  move_in_timeline: string;
  city: string;
  email: string;
  phone?: string;
  desired_flatmate_gender: 'Male' | 'Female' | 'Any';
  pet_friendly?: boolean;
  okay_with_smoker?: boolean;
  you_are?: string;
  comfortable_with?: string;
  food_preference?: string;
  employment_status?: string;
  smoking_habits?: string;
  bath_type?: string;
  amenities?: string[];
  utilities_included?: string[];
  pets_allowed_status?: string;
  transit_distance?: string;
  school_rating?: number;
  furnishing?: string;
  description?: string;
  lifestyle?: string;
  created_at: string;
  updated_at: string;
  matched_listings?: string[];
}

export interface RentalListing {
  id: string;
  listing_type: 'RentingRoom' | 'RentingWhole';
  property_type?: string;
  budget: number;
  budget_per_room?: number;
  bhk: number;
  address: string;
  city: string;
  latitude: number;
  longitude: number;
  email: string;
  phone?: string;
  desired_tenant_gender: 'Male' | 'Female' | 'Any';
  baths?: string;
  bath_type?: string;
  you_are?: string;
  comfortable_with?: string;
  employment_status?: string;
  smoking_habits?: string;
  amenities?: string[];
  utilities_included?: string[];
  pets_allowed_status?: string;
  transit_distance?: string;
  school_rating?: number;
  furnishing?: string;
  availability?: string;
  food_preference?: string;
  lifestyle?: string;
  description?: string;
  created_at: string;
  updated_at: string;
  matched_searches?: string[];
}

export interface Report {
  id: string;
  rent_pin_id: string;
  reason: 'IncorrectPrice' | 'InvalidAddress' | 'InappropriateContent' | 'Other';
  description?: string;
  reporter_email?: string;
  status: 'pending' | 'reviewed' | 'resolved';
  created_at: string;
}

export interface PinFormData {
  address: string;
  city: string;
  bedrooms: number;
  monthlyRent: number;
  furnishing: 'Furnished' | 'Semi-Furnished' | 'Unfurnished';
  residentsType: 'Family' | 'Bachelor' | 'Mixed';
  petsAllowed: boolean;
  squareFootage?: number;
  email?: string;
  phone?: string;
  anonymousSubmission: boolean;
}

export const GTA_CITIES = [
  'Ajax', 'Aurora', 'Brampton', 'Burlington', 'Caledon', 'Cambridge',
  'Durham', 'East Gwillimbury', 'Georgina', 'Halton', 'Halton Hills',
  'Hamilton', 'Kitchener', 'Markham', 'Mississauga', 'Milton',
  'Newmarket', 'Oakville', 'Oshawa', 'Peel', 'Pickering', 'Richmond Hill',
  'Toronto', 'Vaughan',
  'Whitchurch-Stouffville', 'Whitby',
];
